import React from 'react';
import mobilePhoneIcon from 'assets/icons/mobilePhone.svg';
import mailIcon from 'assets/icons/Mail.svg';
import whatsappIcon from 'assets/icons/whatsapp.svg';
import { buildMailtoHref, buildTelHref, buildWhatsAppHref } from 'utils/buildContactLinks';
import { ContactIconLink, ContactIconsGroup } from './styles';

type ContactPhoneIconsProps = {
  phone: string;
  whatsappPhone?: string;
  phoneLabel?: string;
};

type ContactEmailIconsProps = {
  email: string;
  emailLabel?: string;
};

export function ContactPhoneIcons({
  phone,
  whatsappPhone,
  phoneLabel = 'Ligar',
}: ContactPhoneIconsProps): JSX.Element | null {
  const telHref = buildTelHref(phone);
  const whatsappHref = buildWhatsAppHref(whatsappPhone || phone);

  if (!telHref && !whatsappHref) {
    return null;
  }

  return (
    <ContactIconsGroup>
      {telHref && (
        <ContactIconLink href={telHref} aria-label={`${phoneLabel} por telefone`}>
          <img src={mobilePhoneIcon} alt="" aria-hidden />
        </ContactIconLink>
      )}
      {whatsappHref && (
        <ContactIconLink
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${phoneLabel} por WhatsApp`}
        >
          <img src={whatsappIcon} alt="" aria-hidden />
        </ContactIconLink>
      )}
    </ContactIconsGroup>
  );
}

export function ContactEmailIcon({
  email,
  emailLabel = 'Enviar e-mail',
}: ContactEmailIconsProps): JSX.Element | null {
  const mailtoHref = buildMailtoHref(email);

  if (!mailtoHref) {
    return null;
  }

  return (
    <ContactIconsGroup>
      <ContactIconLink href={mailtoHref} aria-label={emailLabel}>
        <img src={mailIcon} alt="" aria-hidden />
      </ContactIconLink>
    </ContactIconsGroup>
  );
}
